var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitorGraphSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2658",
    "data-name": "Group 2658",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 14.444,
    viewBox: "0 0 18 14.444",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1784",
    "data-name": "Rectangle 1784",
    width: 18,
    height: 14.444,
    fill: "#610D24"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2657",
    "data-name": "Group 2657",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3713",
    "data-name": "Path 3713",
    d: "M18,34.6V40.13H0V39.1l4.558-2.735A1.659,1.659,0,0,0,6.951,36.1l3.742,1.253a1.686,1.686,0,0,0,3.371-.035,1.777,1.777,0,0,0-.034-.337Z",
    transform: "translate(-0.001 -31.13)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3714",
    "data-name": "Path 3714",
    d: "M18,104.709v.571a1.126,1.126,0,0,1-1.125,1.125H10.921l1.291,1.289a.563.563,0,0,1-.4.96H6.189a.563.563,0,0,1-.4-.96l1.289-1.289H1.126A1.126,1.126,0,0,1,0,105.28v-.571Z",
    transform: "translate(-0.001 -94.211)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3715",
    "data-name": "Path 3715",
    d: "M16.875,0H1.125A1.127,1.127,0,0,0,0,1.125V6.657L3.971,4.274a1.751,1.751,0,0,1-.034-.336A1.686,1.686,0,0,1,7.309,3.9L11.05,5.156a1.66,1.66,0,0,1,2.393-.264L18,2.157V1.125A1.126,1.126,0,0,0,16.875,0",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3716",
    "data-name": "Path 3716",
    d: "M51.059,33.664a.562.562,0,1,1-.563.563.562.562,0,0,1,.563-.563",
    transform: "translate(-45.434 -30.289)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3717",
    "data-name": "Path 3717",
    d: "M118.388,56.107a.562.562,0,1,1-.562.563.562.562,0,0,1,.562-.563",
    transform: "translate(-106.013 -50.482)",
    fill: "#610D24"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1783",
    "data-name": "Rectangle 1783",
    width: 18,
    height: 0.006,
    transform: "translate(0 8.994)",
    fill: "#610D24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitorGraphSelected);
export default __webpack_public_path__ + "static/media/monitor_graph_selected.761db59a0249c7bba24650f6d5e3241c.svg";
export { ForwardRef as ReactComponent };